/*
 * LA FRASE ITALIANA SEGNATA PER IL DIZIONARIO, dove non si puo' tradurre
 * subito.
 *
 * Le parole del sito passano da t('…') nel punto in cui si scrivono. Ma
 * alcune nascono prima: le etichette di una tabella scritta in testa al
 * file, un messaggio messo da parte nello stato e mostrato dopo. Li' non
 * c'e' ancora una lingua da scegliere, e tradurre subito vorrebbe dire
 * restare nella lingua di quel momento anche se il cliente la cambia.
 *
 * frase() non fa niente: restituisce la frase com'e'. Serve a due cose:
 *   1. alla raccolta (scripts/raccogli-parole.mjs), che la vede come t() e
 *      la mette nel dizionario;
 *   2. a chi legge il codice, che capisce che quella frase va tradotta
 *      DOPO, con t(frase) nel punto in cui si scrive sullo schermo.
 *
 * COSA NON FA: non traduce. Una frase segnata e mai passata da t() si vede
 * in italiano in tutte le lingue.
 */
export function frase(testo) {
  return testo;
}
